import styled, { keyframes } from "styled-components";

interface DotProps {
  dotBackgroundColor: string
  opacity: number
  animationDelay: number
}

const Dot = (props : DotProps) => {
  const Pulse = keyframes`
    0% {
      opacity: 0.4;
      transform: scale(1, 1);
    }

    50% {
      opacity: 1;
      transform: scale(1.2, 1.2);
    }

    100% {
      opacity: 0.4;
      transform: scale(1, 1);
    }
  `;

  const PulseDot = styled.div`
    animation: ${Pulse} 1.5s ease infinite;
    width:30%;
    height:100%;
    border-radius: 25px;
    background-color: ${props.dotBackgroundColor};
    opacity: ${props.opacity};
    animation-delay: ${props.animationDelay}s;

    &:not(:last-child){
      margin-right:5px;
    }
  `;

  return (<PulseDot></PulseDot>)
}

interface DotsLoaderProps {
  width: number
  height: number
  dotBackgroundColor: string
}

const DotsLoader = (props: DotsLoaderProps) => {
    const DotsContainer = styled.div`
        width: ${props.width.toString()}px;
        height: ${props.height.toString()}px;
        display: flex;
        justify-content: space-between;
    `;

    return (
        <DotsContainer>
           <Dot dotBackgroundColor={props.dotBackgroundColor} opacity={0.5} animationDelay={1.5} ></Dot>
           <Dot dotBackgroundColor={props.dotBackgroundColor} opacity={1} animationDelay={0.5}></Dot>
           <Dot dotBackgroundColor={props.dotBackgroundColor} opacity={1} animationDelay={1}></Dot>
        </DotsContainer>
    )
}

export default DotsLoader;